(function () {
  const DRAWER_SELECTOR = '#MinimogCartDrawer';
  const SUBTOTAL_PRICE_SELECTOR = '#MinimogCartDrawer [data-cart-subtotal-price]';

  const CART_DRAWER_SECTION_ID = 'cart-drawer';

  function injectAtcStateStyles() {
    if (document.getElementById('ca-atc-state-styles')) return;

    const style = document.createElement('style');
    style.id = 'ca-atc-state-styles';
    style.textContent = `
      .m-product-card__cta-strip.ca-variant-is-adding {
        pointer-events: none;
      }

      .m-product-card__cta-strip.ca-variant-is-adding [data-toggle-variant-panel],
      .m-product-card__cta-strip.ca-variant-is-adding .m-add-to-cart {
        opacity: 0.78;
        cursor: wait !important;
      }

      .m-product-card__variant-panel.ca-variant-panel-loading {
        pointer-events: none;
      }
    `;

    document.head.appendChild(style);
  }

  async function fetchCartJSON() {
    const res = await fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!res.ok) {
      throw new Error('Could not fetch cart.');
    }

    return res.json();
  }

  function getCartUrl() {
    if (
      window.MinimogSettings &&
      window.MinimogSettings.routes &&
      window.MinimogSettings.routes.cart
    ) {
      return window.MinimogSettings.routes.cart;
    }

    return '/cart';
  }

  function getSectionsUrl() {
    return window.location.pathname || '/';
  }

  function getBundledSectionPayload(extraPayload) {
    return {
      ...extraPayload,
      sections: [CART_DRAWER_SECTION_ID],
      sections_url: getSectionsUrl(),
    };
  }

  async function updateCartLines(updates) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(
        getBundledSectionPayload({
          updates,
        })
      ),
    });

    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data?.description || data?.message || 'Could not update cart.');
    }

    return res.json();
  }

  function isSameVariantWithoutSellingPlan(item, variantId) {
    return (
      Number(item.variant_id) === Number(variantId) &&
      !item.selling_plan_allocation
    );
  }

  async function addToCart(variantId, quantity = 1) {
    const cart = await fetchCartJSON();

    const matchingItems = cart.items.filter(function (item) {
      return isSameVariantWithoutSellingPlan(item, variantId);
    });

    /*
      If this variant is already in the cart, do NOT call /cart/add.js again.
      Instead, update the existing line quantity.

      If duplicate lines already exist, this also merges them in one /cart/update.js request:
      - first matching line gets the total quantity
      - extra duplicate lines get quantity 0
    */
    if (matchingItems.length > 0) {
      const keepItem = matchingItems[0];

      const currentTotalQuantity = matchingItems.reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);

      const newTotalQuantity = currentTotalQuantity + Number(quantity || 1);

      const updates = {};
      updates[keepItem.key] = newTotalQuantity;

      matchingItems.slice(1).forEach(function (item) {
        updates[item.key] = 0;
      });

      return updateCartLines(updates);
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(
        getBundledSectionPayload({
          id: variantId,
          quantity,
        })
      ),
    });

    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data?.description || 'Could not add to cart.');
    }

    return res.json();
  }

  function formatMoney(cents) {
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function' &&
      window.MinimogSettings &&
      window.MinimogSettings.money_format
    ) {
      return window.Shopify.formatMoney(cents, window.MinimogSettings.money_format);
    }

    const currency =
      window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'USD';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function getSectionHTMLFromState(state) {
    if (!state || !state.sections) return '';

    return (
      state.sections[CART_DRAWER_SECTION_ID] ||
      state.sections.cart_drawer ||
      state.sections['CartDrawer'] ||
      ''
    );
  }

  function replaceSelectorFromFreshDoc(freshDoc, selector) {
    const currentElement = document.querySelector(selector);
    const freshElement = freshDoc.querySelector(selector);

    if (!currentElement || !freshElement) return false;

    currentElement.innerHTML = freshElement.innerHTML;
    return true;
  }

  function renderCartDrawerSectionHTML(sectionHTML) {
    if (!sectionHTML) return false;

    const freshDoc = new DOMParser().parseFromString(sectionHTML, 'text/html');

    const replacedItems = replaceSelectorFromFreshDoc(
      freshDoc,
      '#MinimogCartDrawer [data-minimog-cart-items]'
    );

    replaceSelectorFromFreshDoc(
      freshDoc,
      '#MinimogCartDrawer [data-minimog-cart-discounts]'
    );

    replaceSelectorFromFreshDoc(
      freshDoc,
      '#MinimogCartDrawer [data-cart-subtotal]'
    );

    replaceSelectorFromFreshDoc(
      freshDoc,
      '#MinimogCartDrawer [data-minimog-gift-wrapping]'
    );

    return replacedItems;
  }

  async function fetchFreshCartDrawerHTML() {
    const cartUrl = getCartUrl();
    const url = new URL(cartUrl, window.location.origin);

    url.searchParams.set('section_id', CART_DRAWER_SECTION_ID);
    url.searchParams.set('_ca_atc_refresh', Date.now().toString());

    const res = await fetch(url.toString(), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CA-ATC-Refresh': '1',
      },
    });

    if (!res.ok) {
      throw new Error('Could not refresh cart drawer.');
    }

    return res.text();
  }

  async function updateDrawerSubtotal() {
    const subtotal = document.querySelector(SUBTOTAL_PRICE_SELECTOR);
    if (!subtotal) return;

    try {
      const cart = await fetchCartJSON();
      subtotal.textContent = formatMoney(cart.total_price);
    } catch (error) {
      console.warn('[CA ATC] Could not update subtotal:', error);
    }
  }

  async function refreshCartDrawerHTMLFromState(state) {
    const sectionHTML = getSectionHTMLFromState(state);

    if (sectionHTML && renderCartDrawerSectionHTML(sectionHTML)) {
      return;
    }

    try {
      const fallbackHTML = await fetchFreshCartDrawerHTML();

      if (!renderCartDrawerSectionHTML(fallbackHTML)) {
        await updateDrawerSubtotal();
      }
    } catch (error) {
      console.warn('[CA ATC] Drawer HTML refresh failed:', error);
      await updateDrawerSubtotal();
    }
  }

  function dispatchCartRefreshEvents() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:change'));
    document.dispatchEvent(new CustomEvent('minimog:cart:refresh'));

    if (window.CA_SYNC_CART_DRAWER_STATE) {
      window.CA_SYNC_CART_DRAWER_STATE(0);
      window.CA_SYNC_CART_DRAWER_STATE(500);
      window.CA_SYNC_CART_DRAWER_STATE(1200);
    }
  }

  function openCartDrawer() {
    const drawer = document.querySelector(DRAWER_SELECTOR);

    if (!drawer) {
      console.warn('[CA ATC] Cart drawer was not found.');
      return;
    }

    try {
      if (typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
    } catch (error) {}

    try {
      if (
        window.MinimogTheme &&
        window.MinimogTheme.pubSub &&
        window.MinimogTheme.pubSubEvents &&
        window.MinimogTheme.pubSubEvents.openCartDrawer
      ) {
        window.MinimogTheme.pubSub.publish(
          window.MinimogTheme.pubSubEvents.openCartDrawer
        );
        return;
      }
    } catch (error) {}

    try {
      document.dispatchEvent(new CustomEvent('cart:open'));
      document.dispatchEvent(new CustomEvent('minimog:cart:open'));
      document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      document.dispatchEvent(new CustomEvent('minimog:cart-drawer:open'));
    } catch (error) {}

    drawer.classList.add('m-cart-drawer--active');
    drawer.classList.add('open');
    drawer.setAttribute('open', '');
    drawer.setAttribute('aria-hidden', 'false');

    const inner = drawer.querySelector('.m-cart-drawer__inner');

    drawer.style.setProperty('--m-bg-opacity', '0.5');

    if (inner) {
      inner.style.setProperty('--translate-x', '0');
    }

    document.body.classList.add('m-cart-drawer-open');
    document.documentElement.classList.add('m-cart-drawer-open');
    document.documentElement.classList.add('prevent-scroll');
  }

  async function finishAddToCartFlow(state) {
    /*
      Fast path:
      Use bundled cart-drawer section HTML from /cart/add.js or /cart/update.js.
      Fallback:
      Fetch only the cart-drawer section, not the full current page.
    */
    await refreshCartDrawerHTMLFromState(state);

    dispatchCartRefreshEvents();
    openCartDrawer();

    window.setTimeout(dispatchCartRefreshEvents, 500);
    window.setTimeout(dispatchCartRefreshEvents, 1200);
  }

  function getStripFromPanel(panel) {
    if (!panel) return null;
    return panel.closest('.m-product-card__cta-strip');
  }

  function getToggleFromPanel(panel) {
    const strip = getStripFromPanel(panel);
    if (!strip) return null;
    return strip.querySelector('[data-toggle-variant-panel]');
  }

  function closePanel(panel) {
    if (!panel) return;

    const toggleBtn = getToggleFromPanel(panel);

    panel.setAttribute('hidden', '');
    panel.classList.remove('ca-variant-panel-loading');

    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'false');

      const openLabel = toggleBtn.dataset.labelOpen;
      if (openLabel) toggleBtn.textContent = openLabel;
    }
  }

  function closeAllVariantPanels(exceptPanel) {
    document.querySelectorAll('.m-product-card__variant-panel').forEach(function (panel) {
      if (exceptPanel && panel === exceptPanel) return;
      closePanel(panel);
    });
  }

  function closeVariantPanel(select, toggleBtn) {
    const panel = select.closest('.m-product-card__variant-panel');

    if (panel) {
      panel.setAttribute('hidden', '');
      panel.classList.remove('ca-variant-panel-loading');
    }

    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'false');

      const openLabel = toggleBtn.dataset.labelOpen;
      if (openLabel) toggleBtn.textContent = openLabel;
    }
  }

  function resetVariantSelect(select) {
    if (!select) return;

    select.selectedIndex = 0;
    select.value = '';

    const firstOption = select.querySelector('option[value=""]');

    if (firstOption) {
      firstOption.selected = true;
    }
  }

  function setLoading(select, toggleBtn, isLoading) {
    const strip = select?.closest('.m-product-card__cta-strip');
    const panel = select?.closest('.m-product-card__variant-panel');

    if (strip) {
      strip.classList.toggle('ca-variant-is-adding', isLoading);
    }

    if (panel) {
      panel.classList.toggle('ca-variant-panel-loading', isLoading);
    }

    if (select) {
      select.disabled = isLoading;
      select.setAttribute('aria-busy', String(isLoading));
    }

    if (!toggleBtn) return;

    if (isLoading) {
      if (!toggleBtn.dataset.caOriginalText) {
        toggleBtn.dataset.caOriginalText = toggleBtn.textContent.trim();
      }

      toggleBtn.classList.add('is-loading');
      toggleBtn.setAttribute('aria-busy', 'true');
      toggleBtn.textContent = 'Adding...';
    } else {
      toggleBtn.classList.remove('is-loading');
      toggleBtn.removeAttribute('aria-busy');

      const openLabel = toggleBtn.dataset.labelOpen;
      const originalText = toggleBtn.dataset.caOriginalText;

      toggleBtn.textContent = openLabel || originalText || toggleBtn.textContent;
    }
  }

  function setSimpleButtonLoading(button, isLoading) {
    const strip = button?.closest('.m-product-card__cta-strip');

    if (strip) {
      strip.classList.toggle('ca-variant-is-adding', isLoading);
    }

    if (!button) return;

    button.disabled = isLoading;
    button.setAttribute('aria-busy', String(isLoading));

    if (isLoading) {
      if (!button.dataset.caOriginalText) {
        button.dataset.caOriginalText = button.textContent.trim();
      }

      button.classList.add('is-loading');
      button.textContent = 'Adding...';
    } else {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      button.disabled = false;
      button.textContent = button.dataset.caOriginalText || 'Add to Cart';
    }
  }

  injectAtcStateStyles();

  /*
    Variant product card:
    Opens/closes the custom variant dropdown panel.
  */
  document.addEventListener('click', function (e) {
    const target = e.target;
    if (!target || !target.closest) return;

    const toggleBtn = target.closest('[data-toggle-variant-panel]');

    if (toggleBtn) {
      const strip = toggleBtn.closest('.m-product-card__cta-strip');

      if (strip && strip.classList.contains('ca-variant-is-adding')) {
        e.preventDefault();
        return;
      }

      const panel = strip?.querySelector('.m-product-card__variant-panel');
      if (!panel) return;

      const isOpen = !panel.hasAttribute('hidden');

      if (isOpen) {
        closePanel(panel);
        return;
      }

      closeAllVariantPanels(panel);

      panel.removeAttribute('hidden');
      toggleBtn.setAttribute('aria-expanded', 'true');

      const closeLabel = toggleBtn.dataset.labelClose;
      if (closeLabel) {
        toggleBtn.textContent = closeLabel;
      }

      return;
    }

    const clickedInsideOpenPanel = target.closest('.m-product-card__variant-panel');
    const clickedInsideCtaStrip = target.closest('.m-product-card__cta-strip');

    if (!clickedInsideOpenPanel && !clickedInsideCtaStrip) {
      closeAllVariantPanels();
    }
  });

  /*
    Simple/default-variant product card:
    Intercepts the original Minimog product-card form marked with
    data-ca-smart-card-form="true", then uses our smart addToCart()
    so repeated adds increase quantity instead of creating duplicate lines.
  */
  document.addEventListener(
    'submit',
    async function (e) {
      const form =
        e.target && e.target.closest
          ? e.target.closest('form[data-ca-smart-card-form="true"]')
          : null;

      if (!form) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const variantInput = form.querySelector('[name="id"]');
      const button = form.querySelector('[name="add"], .m-add-to-cart');
      const variantId = Number(variantInput && variantInput.value);

      if (!variantId) {
        alert('This product is not ready to add to cart.');
        return;
      }

      setSimpleButtonLoading(button, true);

      try {
        const state = await addToCart(variantId, 1);
        await finishAddToCartFlow(state);
      } catch (err) {
        alert(err.message);
      } finally {
        setSimpleButtonLoading(button, false);
      }
    },
    true
  );

  /*
    Variant dropdown product card:
    Adds the selected variant through the same smart addToCart() path.
  */
  document.addEventListener('change', async function (e) {
    const target = e.target;
    if (!target || !target.closest) return;

    const select = target.closest('[data-variant-select]');
    if (!select) return;

    const strip = select.closest('.m-product-card__cta-strip');
    const toggleBtn = strip?.querySelector('[data-toggle-variant-panel]');
    const variantId = Number(select.value);

       if (!variantId) return;

    closeVariantPanel(select, toggleBtn);
    setLoading(select, toggleBtn, true);

    try {
      const state = await addToCart(variantId, 1);
      await finishAddToCartFlow(state);

      resetVariantSelect(select);
      closeVariantPanel(select, toggleBtn);
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(select, toggleBtn, false);
    }
  });
})();